exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".halt-sales-adjust-modal .ivu-modal-footer{padding-top:0}", ""]);

// exports
